import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    IOrganisationDetails,
    OrganisationsDetails,
} from "../../types/companySearch/companySearchTypes"

export const companySearchMapper = {
    /**
     * Maps the response from the company search API to the TOrganisationDetails.
     * @param response - The response from the API.
     * @returns The mapped object of type TOrganisationDetails.
     */
    mapOrganisationDetails: (response: unknown): IOrganisationDetails => {
        const res = tsIoValidate<IOrganisationDetails>(
            OrganisationsDetails,
            response,
            "Error mapping organisation details data."
        )
        return res
    },
}
